import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { SessionService } from '../services/session.service';
import { Utils } from '../services/utils.service';

@Pipe({
	name: 'humanDate',
	standalone: true
})
export class HumanDatePipe implements PipeTransform {

	constructor(
		private translate: TranslateService,
		private sessionService: SessionService
	) {}

	transform(dateString: string | null | undefined): string {
		if (!dateString) return '';

		const date: Date = new Date(dateString);
		if (isNaN(date.getTime())) return dateString;

		const currentLang: string = this.sessionService.language || 'en';
		let momentLocale: string = currentLang;
		if (momentLocale === 'bahasa') momentLocale = 'id';
		if (momentLocale === 'zh-hans') momentLocale = 'zh-cn';
		if (momentLocale === 'zh-hant') momentLocale = 'zh-tw';

		moment.locale(momentLocale);

		const now: moment.Moment = moment();
		const messageMoment: moment.Moment = moment(date);
		const diffMinutes: number = now.diff(messageMoment, 'minutes');
		const diffHours: number = now.diff(messageMoment, 'hours');

		if (diffMinutes < 60 || diffHours < 24) return messageMoment.fromNow();

		const today: Date = new Date();
		const yesterday: Date = new Date();
		yesterday.setDate(today.getDate() - 1);

		const dateOnly: string = date.toISOString().split('T')[0];
		const messageDate: Date = new Date(dateOnly);

		let dateLabel: string;
		if (Utils.isSameDay(messageDate, today)) {
			dateLabel = this.translate.instant('TODAY');
		} else if (Utils.isSameDay(messageDate, yesterday)) {
			dateLabel = this.translate.instant('YESTERDAY');
		} else {
			dateLabel = messageDate.toLocaleDateString('uk');
		}

		const hours: string = date.getHours().toString().padStart(2, '0');
		const minutes: string = date.getMinutes().toString().padStart(2, '0');
		return `${dateLabel}, ${hours}:${minutes}`;
	}
}
